import React, { useState } from "react";
import styled from "styled-components";
import { Icon } from "../../../../../components/Icon";
import { LightboxClose } from "../../../../../components/Lightbox";
import { CTA } from "../../../../../components/CTA";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { Option, Select } from "../../../../../components/Select";
const StylableMastheadModal = ({ className, title, description, buttons, firstModalButtonCustomAction, secondModalButtonCustomAction, psRegions, }) => {
    const [selectedRegion, setSelectedRegion] = useState(psRegions?.[0].region);
    return (React.createElement("div", { "data-testid": "connect-console-modal", className: className, onClick: (e) => e.stopPropagation() },
        React.createElement(LightboxClose, { className: "lightbox-button" },
            React.createElement(Icon, { className: "close-icon", name: "close" })),
        React.createElement("div", { className: "main-content" },
            React.createElement("div", { className: "header" },
                title && React.createElement("h3", null, title),
                description && React.createElement("p", { className: "description" }, description)),
            psRegions?.length && (React.createElement("div", { className: "region-selector" },
                React.createElement(Select, { value: selectedRegion, onValueChange: setSelectedRegion, defaultValue: psRegions[0].region }, psRegions.map(({ title, region }) => (React.createElement(Option, { key: title, value: region }, title)))))),
            React.createElement("div", { className: "buttons" },
                React.createElement("div", { className: "button-container" },
                    React.createElement(CTA, { variant: "secondary", onClick: firstModalButtonCustomAction }, buttons?.[0]?.title)),
                React.createElement("div", { className: "button-container" },
                    React.createElement(CTA, { variant: "primary", onClick: () => secondModalButtonCustomAction(selectedRegion) }, buttons?.[1]?.title))))));
};
export const BetaMastheadModal = styled(StylableMastheadModal) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=BetaMastheadModal.js.map